// extracted by css-extract-rspack-plugin
export default {"root":"root-W9CsAs text-base-medium","stretchButton":"stretchButton-oYpCQn","fill":"fill-qvhwqy","input":"input-lxgiSO","hover":"hover-BP_T2g"};